import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DeletAccountComponent } from '../../components/delet-account/delet-account.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProfileUpdate, UserProfile } from '../../interfaces/perfil-user.interfaces';
import { PerfilUserService } from '../../service/perfil-user.service';
import { finalize } from 'rxjs';
import { HeaderComponent } from "../../components/header/header.component";
import { ListBanksComponent } from "../../../../shared/components/list-banks/list-banks.component";
import { BankData } from "../../../../shared/components/list-banks/interfaces/list-banks.interface";

@Component({
  selector: 'perfil-user-pages-account',
  imports: [CommonModule, ReactiveFormsModule, DeletAccountComponent, HeaderComponent, ListBanksComponent],
  templateUrl: './account.component.html',
  styleUrl: './account.component.css'
})
export class AccountComponent {
  profileForm: FormGroup;
  userProfile: UserProfile | null = null;
  isLoading = false;
  isSaving = false;
  successMessage = '';
  errorMessage = '';
  // Nombre del banco sólo para visualización en UI
  selectedBankName: string = '';

  constructor(
    private fb: FormBuilder,
    private perfilUserService: PerfilUserService
  ) {
    this.profileForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ ]+$')]],
      lastname: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ ]+$')]],
      phone: ['', [Validators.pattern('^[0-9]+$'), Validators.maxLength(13),Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      NameBank: [0, [Validators.required]],
      Clabe: ['', [Validators.required, Validators.minLength(18), Validators.maxLength(18), Validators.pattern('^[0-9]+$')]]
    });
  }
  ngOnInit(): void {
    this.loadUserProfile();
  }

  loadUserProfile(): void {
    this.isLoading = true;

    this.perfilUserService.getProfile()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (response) => {
          this.userProfile = response.data;
          // Mostrar nombre del banco en la UI si existe en el perfil
          this.selectedBankName = this.userProfile.name_bank || '';
          this.profileForm.patchValue({
            name: this.userProfile.ua_name,
            lastname: this.userProfile.ua_lastname,
            phone: this.userProfile.ua_phone ,
            email: this.userProfile.ua_email,
            // NameBank se mantiene hasta que el usuario seleccione un banco (id)
            Clabe: this.userProfile.BankAccountClabe
          });
        },
      });
  }

  onClabeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[^0-9]/g, '').slice(0, 18);
    this.profileForm.get('Clabe')?.setValue(sanitized, { emitEvent: false });
  }

  onBankSelected(bank: BankData): void {
    // Guardar id numérico en el formulario y el nombre para visualización
    this.profileForm.patchValue({ NameBank: bank.id_banco });
    this.selectedBankName = bank.Nombre;
  }

  onSubmit(): void {
    if (this.profileForm.invalid) {
      this.profileForm.markAllAsTouched();
      return;
    }

    this.isSaving = true;

    this.successMessage = '';

    const profileData: ProfileUpdate = this.profileForm.value;

    this.perfilUserService.updateProfile(profileData)
      .pipe(finalize(() => this.isSaving = false))
      .subscribe({
        next: (response) => {
          this.successMessage = 'Perfil actualizado correctamente';
          this.userProfile = response.data;
          setTimeout(() => this.successMessage = '', 3000);
        },
      });
  }

  // Getters para facilitar la validación en la plantilla
  get nameControl() { return this.profileForm.get('name'); }
  get lastnameControl() { return this.profileForm.get('lastname'); }
  get phoneControl() { return this.profileForm.get('phone'); }
  get emailControl() { return this.profileForm.get('email'); }
  get nameBankControl() { return this.profileForm.get('NameBank'); }
  get clabeControl() { return this.profileForm.get('Clabe'); }
}
